import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchUserData } from "services/apis";


const initialState = {
  userData: [], 
  totalCount: 0,
  status: "idle", 
  loading: false,
  error: null,
};


export const getUsersData = createAsyncThunk(
  "users/fetchUsersData",
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await fetchUserData({ page, limit }); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch users data");
    }
  }
);


const usersDataSlice = createSlice({
  name: "usersData",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "loading";
      })
      .addCase(getUsersData.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload.userData; 
        state.totalCount = action.payload.totalCount;
        state.status = "succeeded";
      })
      .addCase(getUsersData.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload; 
      });
  },
});

export default usersDataSlice.reducer;